import { useEffect, useState } from 'react';
import { LocalAudioTrack, RemoteAudioTrack } from 'twilio-video';

type Track = LocalAudioTrack | RemoteAudioTrack | undefined;

export default function useAudioToggle(track: Track) {
    const [isAudioEnabled, setAudioEnabled] = useState(track ? track.isEnabled : false);

    const toggleAudioEnabled = () => {
        if (track && track instanceof LocalAudioTrack) {
            if (track.isEnabled) {
                track.disable();
            } else {
                track.enable();
            }
        }
    };

    const handleEnabled = () => {
        setAudioEnabled(true);
    };

    const handleDisabled = () => {
        setAudioEnabled(false);
    };

    useEffect(() => {
        if (track) {
            setAudioEnabled(track.isEnabled);
            track.on('enabled', handleEnabled);
            track.on('disabled', handleDisabled);
        }
        return () => {
            track?.off('enabled', handleEnabled);
            track?.off('disabled', handleDisabled);
        };
    }, [track]);

    return { isAudioEnabled, toggleAudioEnabled };
}
